import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function VariablesRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.VariableGroup />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.VariableGroup />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.VariableGroup />
            </Route>
            <Route path={ `${ path }/:group` } >
                { ({ match, history }) => <Pages.VariableList match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.VariableList />
            </Route>
        </Switch>
    );
}

